"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKProgressExampleCodeSegments = exports.GKProgressExample = void 0;
var React = __importStar(require("react"));
var components_1 = require("../../components");
var GKProgressExample = function () {
    var _a = React.useState(0), value = _a[0], setValue = _a[1];
    var tick = function () {
        setValue(function (currentValue) {
            if (currentValue === 100) {
                return 0;
            }
            else {
                return Math.min(currentValue + Math.floor(Math.random() * 12), 100);
            }
        });
    };
    React.useEffect(function () {
        var timerId = window.setInterval(tick, 250);
        return function () { return window.clearInterval(timerId); };
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("h3", null, "Determinate"),
            React.createElement(Bars, { value: value })),
        React.createElement("p", null,
            React.createElement("h3", null, "TODO: "),
            React.createElement("ul", null,
                React.createElement("li", null, "Animation"),
                React.createElement("li", null, "Indeterminate state"),
                React.createElement("li", null, "Multi-bar Loader"),
                React.createElement("li", null, "Inverse Colors?"),
                React.createElement("li", null, "Spinner?")))));
};
exports.GKProgressExample = GKProgressExample;
var Bars = function (props) { return (React.createElement("div", { className: "p-2 m-1" },
    React.createElement("div", { className: "text-center py-2" },
        "Primary (",
        props.value || "undefined",
        "%)"),
    React.createElement(components_1.GKProgress, __assign({}, props, { color: "primary" })),
    React.createElement("div", { className: "text-center py-2" },
        "Secondary (",
        props.value || "undefined",
        "%)"),
    React.createElement(components_1.GKProgress, __assign({}, props, { color: "secondary" })),
    React.createElement("div", { className: "text-center py-2" },
        "Success (",
        props.value || "undefined",
        "%)"),
    React.createElement(components_1.GKProgress, __assign({}, props, { color: "success" })),
    React.createElement("div", { className: "text-center py-2" },
        "Danger (",
        props.value || "undefined",
        "%)"),
    React.createElement(components_1.GKProgress, __assign({}, props, { color: "danger" })),
    React.createElement("div", { className: "text-center py-2" },
        "Warning (",
        props.value || "undefined",
        "%)"),
    React.createElement(components_1.GKProgress, __assign({}, props, { color: "warning" })),
    React.createElement("div", { className: "text-center py-2" },
        "Info (",
        props.value || "undefined",
        "%)"),
    React.createElement(components_1.GKProgress, __assign({}, props, { color: "info" })),
    React.createElement("div", { className: "text-center py-2" },
        "Light (",
        props.value || "undefined",
        "%)"),
    React.createElement(components_1.GKProgress, __assign({}, props, { color: "light" })),
    React.createElement("div", { className: "text-center py-2" },
        "Dark (",
        props.value || "undefined",
        "%)"),
    React.createElement(components_1.GKProgress, __assign({}, props, { color: "dark" })))); };
// AUTOGENERATED:
/* eslint-disable prettier/prettier */
exports.GKProgressExampleCodeSegments = [""];
/* eslint-enable prettier/prettier */
